<script setup lang="ts">
import LanguageSelector from '~/components/footer/LanguageSelector.vue'
import { LEGAL_ENTITIES } from '~/composables/city'
import { translate } from '~/composables/translate/translations'
import { useLocationStore } from '~/stores/location'

const imprint = computed(() => translate('footer_notes_legal_imprint', { '{country}': useLocationStore().city.country }))

const privacyNote = computed(() => translate('footer_notes_legal_privacy', { '{country}': useLocationStore().city.country }))

const companyCopyrights = computed(() => `${new Date().getFullYear()} ${LEGAL_ENTITIES[useLocationStore().city.locationId]}`)

function openUserCentrics() {
  if (window.__ucCmp && window.__ucCmp.isInitialized()) {
    window.__ucCmp.showSecondLayer()
  }
  else {
    window.addEventListener('UC_UI_INITIALIZED', () => {
      window.__ucCmp.showSecondLayer()
    })
  }
}
</script>

<template>
  <footer class="bg-cotton">
    <section
      class="flex fle-row flex-wrap justify-center py-[42px] px-24 gap-y-[40px] items-center
             lg:container lg:mx-auto lg:flex-no-wrap lg:justify-between lg:px-0"
    >
      <LanguageSelector class="basis-1/2 lg:order-last lg:basis-1/5" data-testid="language-selector" />
      <div class="contents lg:inline-flex lg:w-fit lg:basis-2/5">
        <p class="text-black-100 text-center basis-1/2 lg:basis-full" v-html="imprint" />
        <p class="text-black-100 text-center basis-1/2 lg:basis-full" v-html="privacyNote" />
        <a class="text-black-100 text-center basis-1/2 lg:basis-full" role="button" @click="openUserCentrics">
          {{ translate('footer_cookies_prebooking') }}
        </a>
      </div>
      <p class="text-black-100 w-full text-center lg:-order-1 lg:basis-2/5 lg:text-left">
        &copy; {{ companyCopyrights }}
      </p>
    </section>
  </footer>
</template>
